import { Guid } from "@/Common/Models/Guid";

class InboundFaxTriageFormSettingsModel {
    public SelectedDocumentClassIds: (Guid | string)[];
}

export { InboundFaxTriageFormSettingsModel };
